import { PeerTypes, useShowCampaignById_new } from '@givebacks/api/store';
import { useForm } from '@givebacks/formy';
import { useDonorTranslations } from 'core';
import { Stack, Text } from 'ui';
import { hasLength } from 'ui/Form';

import { PeerSelect } from './PeerSelect/PeerSelect';
import { PeerCreditForm } from './usePeerCredits';

type RegistrantSelectProps = {
  type: PeerTypes;
  storeItemId: string;
  storeId: string;
};

const PeerSelection = ({ type, storeItemId, storeId }: RegistrantSelectProps) => {
  const { data: campaign } = useShowCampaignById_new({ campaignId: storeItemId, causeId: storeId });
  const { t } = useDonorTranslations({
    storeItemId,
    storeId,
  });

  const isMultipleDesignation = campaign?.__type == 'campaign' && type === 'participants';

  const form = useForm<PeerCreditForm>(
    {
      initialValues: {
        credits: [{ value: '', type: '', label: '' }],
        peerType: type,
      },
      validate: {
        credits: {
          value: hasLength({ min: 2 }, 'Name should have at least 2 letters'),
        },
      },
    },
    {
      id: 'credits',
    }
  );

  if (!type) return null;

  return (
    <Stack>
      <Stack gap={4}>
        <Text fw={600}>
          Choose a {type === 'participants' ? `${t('participant')}` : `${t('team')}`}
        </Text>
        {type === 'participants' && (
          <Text fz="sm" c="gray">
            Select {isMultipleDesignation ? 'one or more' : 'one'}{' '}
            {isMultipleDesignation
              ? t('participants').toLowerCase()
              : t('participant').toLowerCase()}{' '}
            to credit to this donation. A donation may only contain credits from either{' '}
            {t('participants').toLowerCase()} or {t('teams').toLowerCase()}, but not both.
          </Text>
        )}
      </Stack>
      <PeerSelect
        isMultiSelect={isMultipleDesignation}
        type={type}
        form={form}
        storeId={storeId}
        storeItemId={storeItemId}
      />
    </Stack>
  );
};

export { PeerSelection };
